export class Material {
    artikel_id: number;
    bezeichnung: string;
    kuerzel: string;
    artikel_nr_intern: string;
    artikel_me: string;
    ean: string;
    produktkennzeichnungen: string;
    bga: string;
    menge: number;
    gebindegroesse: number;
    einheit: string;
    /** Gespeicherte Einheit, z. B. „1000 ml“, ohne Umrechnung auf Liter. */
    einheit_roh?: string;
    einheit_id: number;
    einheit_alternativ: string;
    einzelpreis: number;
    preiseinheit: number;
    impfung: number;
    behandlung: number;
    abgabe: number;
    abgabeundbehandlung: number;
    anwendungsdauer_fix: number;
    dosierung_fix: number;
    bestandsbesuchsprotokoll: number;
    massnahmenplan_schwein: number;
    massnahmenplan_rind: number;
    massnahmenplan_rind_kurz: number;
    tierwohlprotokoll_schwein: number;
    tierwohlprotokoll_rind: number;
    neuverschreibung: number;
    verpackungsmenge: number;
    antibiotikum: number;
    mindestbestand: number;
    sicherheitsbestand: number;
    sicherheitsbestand_variabel: number;
    lieferant_id: number;
    lieferant: string;
    apotheke: number;
    lager: number;
    wagen: number;
    ausgang: number;
    summe: number;
    bezeichnung_befund: string;
    bestellmenge: number;
    bestellmenge_konstant: number;
    bestellvorschlag: number;
    umrechnungsfaktor: number;
    ermittlung_rohertrag: string;
    laborartikel: number;
    laborartikel_gesperrt: number;
    mengenartikel: number;
    charge: number;
    sonstige_abgabe: number;
    betaeubungsmittel: number;
    nicht_abgebbar: number;
    /** 1 = Praxisverbrauch, 0 = Umsatz/Verkauf, null = aus nicht_abgebbar ableiten */
    verbrauch: number;
    provisionsfaehig: number;
    provision: number;
    rabattfaehig: number;
    bonusfaehig: number;
    skontofaehig: number;
    bestellwesen: number;
    kein_negativbestand: number;
    lagerbestaende_verbuchen: number;
    kein_liefervorschlag: number;
    keine_barcodeerfassung: number;
    sammelartikel: number;
    interne_verrechnung: number;
    tsk_abkuerzung: string;
    tsk_preis: number;
    tsk: number;
    impftext: string;
    // impfgebuehr_0_24: number;
    // impfgebuehr_25_49: number;
    // impfgebuehr_50: number;
    // wartezeit: number;
    warengruppe_id: number;
    warengruppe: string;
    gesperrt: number;
    lieferant_id_labor: number;
    lieferant_labor: string;
    /** Externe Artikelnr. Lieferant (Labor-Suche). */
    artikelnr_lieferant?: string;
    untersuchungsgruppe_id: number;
    untersuchungsgruppe: string;
    untersuchungen_anzahl: number;
    ust: number;
    mandanten_ids: number[] = [];
    warengruppe_labor: number;
    warengruppe_tierarzt: number;
    stueckliste: number;
    wirkstoff_id: number;
    wirkstoff: string;
    artikelmenge_ausblenden: number;
    in_abgangsliste: number;
    honorar: number;
    primanota_ignorieren: number;
    faktor: number;
    buchungskonto?: string;
    buchungsgegenkonto?: string;
    /** Verkaufs-Erlöskonto-Basis (Kunden-Primanota). Suffix je Betriebsart live ab FIBU_ERLOES_SUFFIX_AB. */
    erloeskonto?: string;

    // impfgebuehr_0_24: number;
    // impfgebuehr_25_49: number;
    // impfgebuehr_50: number;
    wartezeit: number;
    idexx: number;
    idexx_messgroesse: string;
    idexx_pdf_beschreibung: string;
    idexx_pdf_tabellen_text: string;
    tourenplan: number;
    tourenplan_tage: number;
    packungs_id: number;
    eingangsnummer: number;
    upd: string;
    got: number;
}

/** 3400 am Stamm ist Alt-Default, keine FiBu-Ausnahme (4930/4900 bleiben). */
function einkaufStammkontoAusnahme(konto?: string | null): string {
    const art = (konto || '').trim();
    if (!art || art === '3400' || art.startsWith('3400.')) {
        return '';
    }
    return art;
}

/** Stichtag: Stammkonten 4981/4982 und Live-Artikel-Primanota erst ab diesem Tag. */
export const FIBU_EINKAUF_ARTIKEL_AB = '2027-01-01';

/**
 * Stichtag Erlöse: Betriebsart-Suffix an Artikel-Basis (8400.11 usw.).
 * Gleicher Cutover wie Einkauf – bis dahin Primanota ohne Suffix (nur Basis).
 * Pflege unter Finanzen → Erlös-Suffixe ist vorher schon erlaubt.
 */
export const FIBU_ERLOES_SUFFIX_AB = '2027-01-01';

export function isFibuEinkaufArtikelAbAktiv(
    asOf: Date | string | null | undefined = new Date(),
): boolean {
    return isFibuStichtagAktiv(asOf, FIBU_EINKAUF_ARTIKEL_AB);
}

export function isFibuErloesSuffixAbAktiv(
    asOf: Date | string | null | undefined = new Date(),
): boolean {
    return isFibuStichtagAktiv(asOf, FIBU_ERLOES_SUFFIX_AB);
}

function isFibuStichtagAktiv(
    asOf: Date | string | null | undefined,
    stichtagYmd: string,
): boolean {
    let ymd: string;
    if (asOf == null) {
        const n = new Date();
        ymd = `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(
            n.getDate(),
        ).padStart(2, '0')}`;
    } else if (typeof asOf === 'string') {
        ymd = asOf.slice(0, 10);
    } else {
        ymd = `${asOf.getFullYear()}-${String(asOf.getMonth() + 1).padStart(2, '0')}-${String(
            asOf.getDate(),
        ).padStart(2, '0')}`;
    }
    return ymd >= stichtagYmd;
}

/**
 * Aufwandskonto Einkauf.
 * Ab 1.1.2027: Umsatz/Weiterberechnung 3400 (auch Labor), Praxis 4981, Laborverbrauch 4982.
 * Bis dahin: Lieferant/3400 (Verbrauch-Flag ändert das Konto noch nicht).
 * `artikelKonten: true` = Vorschau „Neu“ auch vor dem Stichtag.
 */
export function einkaufAufwandskonto(
    artikel: Partial<Material> | null | undefined,
    lieferantGegenkonto?: string | null,
    options?: { artikelKonten?: boolean; asOf?: Date | string | null },
): string {
    const rec = artikel as (Partial<Material> & { buchungskonto?: string }) | null | undefined;
    const labor = Number(rec?.laborartikel) > 0;
    const verbrauch = isEinkaufVerbrauchArticle(rec, labor);
    const art = einkaufStammkontoAusnahme(rec?.buchungskonto);
    const lief = (lieferantGegenkonto || '').trim();
    const artikelKonten =
        options?.artikelKonten ?? isFibuEinkaufArtikelAbAktiv(options?.asOf);
    if (!artikelKonten) {
        return art || lief || '3400';
    }
    if (labor && verbrauch) {
        return art || '4982';
    }
    if (verbrauch) {
        return art || '4981';
    }
    return art || lief || '3400';
}

function isApiFlagOne(v: unknown): boolean {
    return v === 1 || v === '1' || v === true || Number(v) === 1;
}

function isApiFlagZero(v: unknown): boolean {
    return v === 0 || v === '0' || v === false;
}

/** Labor-Katalog: Warengruppe Laborartikel oder Diagnostikartikel. */
export function isEinkaufLaborArticle(
    m: { warengruppe?: unknown } | null | undefined,
): boolean {
    if (!m) {
        return false;
    }
    const wg = String(m.warengruppe || '')
        .trim()
        .toLowerCase();
    return wg === 'laborartikel' || wg === 'diagnostikartikel';
}

/**
 * Bestell-Einheit für Labor- und Diagnostikartikel.
 * Eine gesetzte Lagereinheit bleibt. Sonst VE, wenn der Inhalt größer als 1 ist, sonst Stück.
 * `inhalt` ist der Text aus gibEinheit („50 Stk“) oder nur die Einheitsbezeichnung.
 */
export function laborBestellEinheit(einheitAlternativ: unknown, inhalt?: unknown, menge?: unknown): string {
    const pack = String(einheitAlternativ ?? '').trim();
    if (pack && pack !== '1') {
        return pack;
    }
    return laborInhaltAnzeige(inhalt, menge) ? 'VE' : 'Stück';
}

/**
 * Lagereinheit zur Anzahl: 1 Dose, 13 Dosen.
 * Gleiche Liste wie BestellungExtern::laborEinheitForm.
 */
export function laborEinheitForm(einheit: unknown, anzahl: unknown): string {
    const wort = String(einheit ?? '').trim();
    if (!wort) {
        return wort;
    }
    const key = wort.toLocaleLowerCase('de-DE');
    const plural = Number(anzahl) !== 1;
    const form = LABOR_EINHEIT_FORMEN[key];
    if (form) {
        return laborEinheitGross(wort, plural ? form[1] : form[0]);
    }
    if (!plural) {
        return wort;
    }
    if (/ung$/i.test(key)) {
        return wort + 'en';
    }
    if (/e$/i.test(key)) {
        return wort + 'n';
    }
    return wort;
}

function laborEinheitGross(original: string, form: string): string {
    const first = original.charAt(0);
    if (first === first.toLocaleLowerCase('de-DE')) {
        return form.charAt(0).toLocaleLowerCase('de-DE') + form.slice(1);
    }
    return form;
}

const LABOR_EINHEIT_FORMEN: Record<string, [string, string]> = {
    dose: ['Dose', 'Dosen'],
    dosen: ['Dose', 'Dosen'],
    flasche: ['Flasche', 'Flaschen'],
    flaschen: ['Flasche', 'Flaschen'],
    box: ['Box', 'Boxen'],
    boxen: ['Box', 'Boxen'],
    karton: ['Karton', 'Kartons'],
    kartons: ['Karton', 'Kartons'],
    packung: ['Packung', 'Packungen'],
    packungen: ['Packung', 'Packungen'],
    pack: ['Pack', 'Packs'],
    packs: ['Pack', 'Packs'],
    schachtel: ['Schachtel', 'Schachteln'],
    schachteln: ['Schachtel', 'Schachteln'],
    kiste: ['Kiste', 'Kisten'],
    kisten: ['Kiste', 'Kisten'],
    rolle: ['Rolle', 'Rollen'],
    rollen: ['Rolle', 'Rollen'],
    tube: ['Tube', 'Tuben'],
    tuben: ['Tube', 'Tuben'],
    ampulle: ['Ampulle', 'Ampullen'],
    ampullen: ['Ampulle', 'Ampullen'],
    palette: ['Palette', 'Paletten'],
    paletten: ['Palette', 'Paletten'],
    tüte: ['Tüte', 'Tüten'],
    tüten: ['Tüte', 'Tüten'],
    sack: ['Sack', 'Säcke'],
    säcke: ['Sack', 'Säcke'],
    fass: ['Fass', 'Fässer'],
    fässer: ['Fass', 'Fässer'],
    glas: ['Glas', 'Gläser'],
    gläser: ['Glas', 'Gläser'],
    kanister: ['Kanister', 'Kanister'],
    eimer: ['Eimer', 'Eimer'],
    beutel: ['Beutel', 'Beutel'],
    becher: ['Becher', 'Becher'],
    stück: ['Stück', 'Stück'],
    stk: ['Stk', 'Stk'],
    'stk.': ['Stk.', 'Stk.'],
    ve: ['VE', 'VE'],
    gebinde: ['Gebinde', 'Gebinde'],
    paar: ['Paar', 'Paar'],
    set: ['Set', 'Sets'],
    sets: ['Set', 'Sets'],
    flakon: ['Flakon', 'Flakons'],
    flakons: ['Flakon', 'Flakons'],
    behälter: ['Behälter', 'Behälter'],
    einheit: ['Einheit', 'Einheiten'],
    einheiten: ['Einheit', 'Einheiten'],
    paket: ['Paket', 'Pakete'],
    pakete: ['Paket', 'Pakete'],
    vial: ['Vial', 'Vials'],
    vials: ['Vial', 'Vials'],
    kit: ['Kit', 'Kits'],
    kits: ['Kit', 'Kits'],
};

/** Inhalt einer Packung, z. B. „50 Stk“ oder „5 Ltr“. „1 Stück“ und „keine Einheit“ bleiben leer. */
export function laborInhaltAnzeige(inhalt: unknown, menge?: unknown): string {
    const text = String(inhalt ?? '').trim();
    if (!text || /keine\s+einheit/i.test(text)) {
        return '';
    }
    const formatiert = text.match(/^(\d+(?:,\d+)?)\s+\S/);
    if (formatiert) {
        const wert = Number(formatiert[1].replace(',', '.'));
        return wert > 1 ? text : '';
    }
    const zahl = Number(menge);
    if (zahl > 1) {
        const mengeText = Number.isInteger(zahl) ? String(zahl) : String(zahl).replace('.', ',');
        return mengeText + ' ' + text;
    }
    return '';
}

/** Packungsgröße > 1: die Bestellmenge muss durch diese Zahl teilbar sein. */
export function laborPackSchritt(gebindegroesse: unknown): number | null {
    const n = Number(gebindegroesse);
    if (!Number.isFinite(n) || n <= 1) {
        return null;
    }
    return n;
}

export function laborMengePasstZumPack(menge: unknown, gebindegroesse: unknown): boolean {
    const pack = laborPackSchritt(gebindegroesse);
    const n = Number(menge);
    if (!pack) {
        return true;
    }
    if (!Number.isFinite(n) || n <= 0) {
        return false;
    }
    const vielfaches = n / pack;
    return Math.abs(vielfaches - Math.round(vielfaches)) < 1e-6;
}

export function laborPackInfo(gebindegroesse: unknown): string {
    const pack = laborPackSchritt(gebindegroesse);
    return pack ? `Nur in ${pack}er-Packs bestellbar.` : '';
}

export function laborPackFehler(menge: unknown, gebindegroesse: unknown): string {
    const pack = laborPackSchritt(gebindegroesse);
    const n = Number(menge);
    if (!pack || !Number.isFinite(n) || n <= 0 || laborMengePasstZumPack(n, pack)) {
        return '';
    }
    return `${n} ist nicht durch ${pack} teilbar.`;
}

/** FiBu-Verbrauch: Flag; Impfung/Honorar/Labor ohne Flag = Umsatz, nicht über nicht_abgebbar. */
export function isEinkaufVerbrauchArticle(
    m: (Partial<Material> & { impfung?: unknown; honorar?: unknown }) | null | undefined,
    labor: boolean,
): boolean {
    if (!m) {
        return false;
    }
    const v = m.verbrauch as unknown;
    if (isApiFlagOne(v)) {
        return true;
    }
    if (isApiFlagZero(v)) {
        return false;
    }
    if (labor || isApiFlagOne(m.impfung) || isApiFlagOne(m.honorar)) {
        return false;
    }
    return isVerbrauchArticle(m);
}

/** Praxisverbrauch (Handschuhe) vs. Umsatz (Medikamente, Labor, verkaufte Spritzen). */
export function isVerbrauchArticle(m: Partial<Material> | null | undefined): boolean {
    if (!m) {
        return false;
    }
    const v = m.verbrauch as unknown;
    if (v === 1 || v === '1' || v === true) {
        return true;
    }
    if (v === 0 || v === '0' || v === false) {
        return false;
    }
    const n = m.nicht_abgebbar as unknown;
    return n === 1 || n === '1' || n === true || Number(n) === 1;
}

export class Wirkstoff {
    wirkstoff_id: number;
    wirkstoff: string;
}

export interface MaterialApi {
    records: Material[];
    count: number;
}

export class Einzelpreis {
    einzelpreis: number;
}

export class Warengruppe {
    warengruppe_id: number;
    bezeichnung: string;
}

export interface WarengruppeApi {
    count: number;
    records: Warengruppe[];
}

export class ArtikelAdmin {
    artikel_id: number;
    ust: number;
    buchungskonto: string;
    buchungsgegenkonto: string;
    erloeskonto: string;
    mandanten_ids: number[] = [];
    stueckliste_einkaufspreis: number;
}

export class ArtikelStueckliste {
    as_id: number;
    artikel_id_liste: number;
    artikel_liste: string;
    artikel_id_pos: number;
    artikel_pos: string;
    artikel_nr_intern?: number;
    behandlung_artikel: number;
    abgabe_artikel: number;
    anwendung_id: number;
    anwendung: string;
    anwendungsdauer: number;
    behandlung: number;
    indikation_id: number;
    diagnose: string;
    artikelmenge: number;
    pos_packungsmenge?: number;
    pos_einheit?: string;
    artikel_pos_bezeichnung?: string;
    mengenartikel: number;
    tierart_id: number;
    tierart: string;
    lieferant: string;
    einzelpreis: number;
    wartezeit: number;
    dosierung: number;
    rabatt: number;
    erstellt: Date;
    erstellt_von: number;
    editiert: Date;
    editiert_von: number;
    mandanten_ids: number[] = [];
}

export class ArtikelMedikation {
    am_id: number;
    artikel_id: number;
    artikel_me: string;
    tierart_id: number;
    tierart: string;
    anwendung_id: number;
    anwendung: string;
    indikation_id: number;
    diagnose: string;
    wartezeit_fleisch: number;
    wartezeit_milch: number;
    wartezeit_eier: number;
    kommentar: string;
    menge: number;
    einheit_id: number;
    einheit: string;
    behandlung_tage: number;
    faktor: number;
    intervall_std: number;
    koerpergewicht: number;
    dosierung_txt: string;
    behandlung_tage_txt: string;
    editiert: Date;
}
